<template>
  <div styleName="contentCamaraWrapper">
    <div styleName="content_camara">
      <div styleName="content_camara_left">
        <label for="videoSource">{{ $t('selectVideoDevice') }}</label>
        <select :value="changingVideoDevice ? tempVideoIndex : selectedVideoDeviceIndex" @change="changeDevice">
          <option v-for="(item, index) in videoList" :value="index" :key="index">
            {{item.label || $t('camera') + ' ' + (index + 1)}}
          </option>
        </select>
        <div styleName="camara_wrap" ref="videoWrapper" v-if="videoShow">
          <!-- <video id="localVideo" ref="localVideo" autoplay playsinline></video> -->
          <div styleName="localVideo" ref="localVideo" id="locolVideo"></div>
        </div>
        <p v-if="hasDetect && detectedDevice" styleName="status_nomal">
          <i></i>{{ $t('detectVideo') }}</p>
        <p v-if="hasDetect && !detectedDevice" styleName="status_error">
          <i></i>{{ $t('failDetectVideo') }}</p>
      </div>
    </div>
    <!-- <FooterButton @confirm="_confirm" /> -->
    <div styleName="content_footer">
      <button @click="_confirm" data-role="active">{{ $t('confirm') }}</button>
    </div>
  </div>
</template>
<script>
import styles from './index.scss'
import cssModules from 'vue-css-modules'
import { mediaSDK } from '@/utils/getSDK'
import { mapGetters } from 'vuex'
// import FooterButton from './FooterButton'
import sensorLog from '@/utils/sensorLog'
import * as types from '../../constants'
export default {
  mixins: [cssModules(styles)],
  name: 'camara',
  data: function () {
    return {
      detectedDevice: false,
      hasDetect: false,
      tempVideoIndex: 0,
      changingVideoDevice: false,
      videoShow: false
    }
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(['deviceLists', 'roomDetail','hasPublished']),
    videoList () {
      return this.deviceLists.videoList
    },
    audioList () {
      return this.deviceLists.audioList
    },
    selectedVideoDeviceIndex () {
      return this.$store.state.mediaInfo.selectedDevice.video
    },
    selectedAudioDeviceIndex () {
      return this.$store.state.mediaInfo.selectedDevice.audio
    },
    selectedVideoLabel () {
      return this.deviceLists.videoList[this.selectedVideoDeviceIndex] && this.deviceLists.videoList[this.selectedVideoDeviceIndex].label || `摄像头 ${this.selectedVideoDeviceIndex + 1}`
    },
    selectedDevice () {
      return this.$store.state.mediaInfo.selectedDevice
    },
    usedVideoId () {
      return this.deviceLists.videoList && this.deviceLists.videoList[this.selectedDevice.video].deviceId || ''
    }
  },
  methods: {
    initPlayer (cameraId, microphoneId) {
      let { usrId } = this.roomDetail.data
      this.videoShow = true
      let init = async () => {
        let options = {
          userid: usrId,
          video: true,
          audio: true,
          screen: false,
          cameraId: cameraId,
          microphoneId: microphoneId,
          mirror: false
        }
        console.log('cameraSetting initPlayer')
        try {
          this.localStream = await mediaSDK.getShowMedialStream(options)
        } catch (err) {
          sensorLog.track("hardware_camera_getmediastream", types.SENSORLOG.type.FAILED, err)
          this.$toast.show({
            header: false,
            text: err,
            textStyle: {
              'text-align': 'center'
            },
            btnText: this.$t('refresh'),
            btnOK: () => {
              location.reload()
            }
          })
        }

        try {
          await mediaSDK.playMedial({ videoId: 'locolVideo', stream: this.localStream })
        } catch (err) {
          sensorLog.track("hardware_camera_playmedia", types.SENSORLOG.type.FAILED, err)
          this.$toast.show({
            text: 'playMedial failed!',
            headerDesc: this.$t('attention'),
            buttonCount: 1,
            textStyle: {
              textAlign: 'center'
            },
            btnText: this.$t('btnok'),
            btnOK: () => {
              window.location.reload()
            }
          })
        }
        this.hasDetect = true
        this.detectedDevice = true
      }

      let initDom = async () => {
        await init()
        document.getElementById('locolVideo').style.height = '100%'
      }
      this.$nextTick(() => {
        initDom()
      })
    },
    async changeDevice (e) {
      this.hasDetect = false
      this.changingVideoDevice = true
      this.tempVideoIndex = Number(e.target.value)
      this.detectedDevice = false

      this.videoShow = false
      this.$nextTick(() => {
        this.initPlayer(this.videoList[this.tempVideoIndex].deviceId, this.audioList[this.selectedAudioDeviceIndex].deviceId)
      })
    },
    async _confirm () {
      let chooseId=this.videoList[this.tempVideoIndex].deviceId
      console.log('---chooseId-->',chooseId)
      console.log('---->usedVideoId->',this.usedVideoId)
      if (this.hasPublished && chooseId && chooseId!==this.usedVideoId) {
        this.$store.commit(types.MEDIA_CAMERA_STATUS, false)
      }
      this.changingVideoDevice = false
      this.videoShow = false
      this.$store.dispatch('changeDevice', { video: this.tempVideoIndex })
      sensorLog.track("hardware_camera_change", types.SENSORLOG.type.SUCCESSED, JSON.stringify({ video: this.tempVideoIndex }))
      this.$store.commit(types.ALERT_STATUS, false)
    }
  },
  mounted () {
    let initVideoId = this.videoList[this.selectedVideoDeviceIndex].deviceId
    let initAudioId = this.audioList[this.selectedAudioDeviceIndex].deviceId
    this.initPlayer(initVideoId, initAudioId, true)
  },
  destroyed () {
    // mediaSDK.closeMedial(this.localStream)
  },
  // components: {
  //   FooterButton
  // }
}
</script>
